export const transformRequestServicePoints = ({ orderId, returnId, deliveryMethodId, address, city }) => {
  return {
    orderId,
    returnId,
    params: {
      address,
      city,
      delivery_method_id: deliveryMethodId,
    },
  }
}

const mapServicePoint = servicePoint => {
  return {
    id: servicePoint.id,
    name: servicePoint.name,
    street: servicePoint.street,
    house_number: servicePoint.house_number,
    postal_code: servicePoint.postal_code,
    city: servicePoint.city,
    distance: servicePoint.distance,
  }
}

export const transformResponseServicePoints = servicePoints => {
  return servicePoints ? servicePoints.map(mapServicePoint) : servicePoints
}
